import React from 'react';
import TermDetails from './TermDetails';
import TermPolicyBanner from './TermPolicyBanner';

const TermPolicy = () => {
    return (
        <div>
            <TermPolicyBanner />
            <TermDetails />
        </div>
    );
};

export default TermPolicy;